import _ from "lodash";
import client from "lib/apolloClient/client";
import { studentFragments } from "StudentSetup/modules/StudentFragments";
import {
  getStudentFeedQuery,
  getCoursesOfStudentQuery,
  getOrganizationYearGroupsQuery,
  getStudentsWithoutYearGroupQuery,
  getStudentsWithoutYearGroupCountQuery,
  getOrganizationYearGroupsWithGradesQuery,
} from "StudentSetup/modules/StudentQueries";

export const getStudentFamilyDetails = ({ studentId, variables }) => {
  let queryData = {};
  try {
    queryData = client.readFragment({
      id: `Student:${studentId}`,
      fragment: studentFragments.studentFamilyMembers,
      fragmentName: "studentItem",
      variables,
    });
  } catch (e) {
    return {};
  }
  if (queryData != null) return queryData;
  else return {};
};

export const getStudentDetails = userId => {
  let queryData = {};
  try {
    queryData = client.readFragment({
      id: `Student:${userId}`,
      fragment: studentFragments.studentDetails,
      fragmentName: "studentItem",
    });
  } catch (e) {
    return {};
  }
  // console.log(queryData);
  if (queryData != null) return queryData;
  else return {};
};

export const getStudentFeedForOrganizationFromCache = variables => {
  let queryData = {};
  try {
    queryData = client.readQuery({
      query: getStudentFeedQuery,
      variables: {
        ...variables,
        withStaffRelation: variables.withStaffRelation
          ? variables.withStaffRelation
          : false,
      },
    });
  } catch (e) {
    return {};
  }

  if (queryData != null) return _.get(queryData, "node", {});
  else return {};
};

export const writeStudentFamiliesInCache = ({ studentId, data, variables }) => {
  try {
    client.writeFragment({
      id: `Student:${studentId}`,
      fragment: studentFragments.studentFamilyMembers,
      fragmentName: "studentItem",
      data: data,
      variables,
    });
  } catch (e) {}
};

export const getCoursesOfStudentFromCache = ({ studentId, courseFilters }) => {
  let queryData = {};
  try {
    queryData = client.readQuery({
      query: getCoursesOfStudentQuery,
      variables: {
        ids: [studentId],
        filters: courseFilters,
      },
    });
  } catch (e) {
    return [];
  }
  if (queryData != null) return _.get(queryData, "platform.student", []);
  else return [];
};

export const getOrganizationYearGroupsFromCache = variables => {
  try {
    const queryData = client.readQuery({
      query: getOrganizationYearGroupsQuery,
      variables,
    });
    return queryData || {};
  } catch (e) {
    return {};
  }
};

export const getOrganizationYearGroupsWithGradesFromCache = variables => {
  try {
    const queryData = client.readQuery({
      query: getOrganizationYearGroupsWithGradesQuery,
      variables,
    });
    return queryData || {};
  } catch (e) {
    return {};
  }
};

export const writeStudentFeedForOrganizationToCache = ({
  variables,
  studentFeedData,
}) => {
  try {
    client.writeQuery({
      query: getStudentFeedQuery,
      variables,
      data: { node: studentFeedData },
    });
  } catch (e) {
    return {};
  }
};

export const getStudentsWithoutYearGroupCountFromCache = variables => {
  try {
    const queryData = client.readQuery({
      query: getStudentsWithoutYearGroupCountQuery,
      variables,
    });
    return _.get(queryData, "node.students.totalCount", 0);
  } catch (e) {
    return 0;
  }
};

export const getStudentsWithoutYearGroupFromCache = variables => {
  try {
    const queryData = client.readQuery({
      query: getStudentsWithoutYearGroupQuery,
      variables,
    });
    return _.get(queryData, "node.students", []);
  } catch (e) {
    return [];
  }
};

export const getStudentFromCacheById = ({ id, variables }) => {
  try {
    const student = client.readFragment({
      id: `Student:${id}`,
      fragment: studentFragments.studentItem,
      fragmentName: "studentItem",
      variables,
    });
    return { node: student };
  } catch (e) {
    return {};
  }
};

export const getStudentFromCacheByIdV2 = ({ id, variables }) => {
  try {
    const student = client.readFragment({
      id: `Student:${id}`,
      fragment: studentFragments.studentItemV2,
      fragmentName: "studentItem",
      variables,
    });
    return { node: student };
  } catch (e) {
    return {};
  }
};
